export const accessList = [
    { value: 'Direto', label: 'Direto' },
    { value: 'Via jump server', label: 'Via jump server' },
    { value: 'Jump server', label: 'Jump server' }
]